/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 配额表单的
 */
export interface QuotaVm {
    fileSystem?: string;
    dtree?: string;
    quotaType?: number;
    spaceQuota?: {
        hard: {
            value: number;
            unit: string;
        };
        soft: {
            value: number;
            unit: string;
        };
    };
    fileQuota?: {
        hard?: number;
        hardUnit?: number;
        soft?: number;
        softUnit?: number;
    };
}

/**
 * 用户/用户组
 */
export interface UserOrGroup {
    /**
     * ID。
     * 本地用户/用户组为接口返回的ID字段
     * 域用户/用户组由名称和类型拼成
     */
    id?: string;
    /**
     * 用户/用户组名称
     */
    USRGRPOWNERNAME?: string;
    /**
     * 用户或用户组的类型
     * 1、本地用户和本地用户组
     * 2、域用户和域用户组
     */
    USRGRPTYPE?: UserOrGroupTypeE;
    /**
     * 名称类型
     * 0、用户名
     * 1、用户组名
     */
    NAMETYPE?: NameTypeE;
    /**
     * 域用户类型
     * 1、AD域
     * 2、LDAP域
     * 3、NIS域
     */
    DOMAINTYPE?: DomainTypeE;
    /**
     * 平台
     * 参考 i18n值
     */
    usrOsType?: UserOsTypeE;
    /**
     * 配额类型
     * 1、目录配额
     * 2、用户配额
     * 3、用户组配额
     */
    QUOTATYPE?: QuotaTypeE;
}

/**
 * 平台类型枚举
 */
export enum UserOsTypeE {
    Unix = 0,
    Windows = 1
}

/**
 * 配额枚举
 */
export enum QuotaTypeE {
    Dtree = 1,
    User = 2,
    UserGroup = 3
}

/**
 * 用户/用户组类型
 */
export enum UserOrGroupTypeE {
    Local = 1,
    Domain = 2
}

/**
 * 名称类型
 */
export enum NameTypeE {
    User = 0,
    Group = 1
}

/**
 * 域类型。特别增加0代表本地
 */
export enum DomainTypeE {
    Local = 0,
    AD = 1,
    LDAP = 2,
    NIS = 3
}

/**
 * 选择用户/用户组类型
 */
export enum SelectTypeE {
    Every = 1,
    SpecificUserOrGroup = 2,
    SpecificUserInGroup = 3
}
